import { useCallback, useState } from "react";

export const useDashboardSearch = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [isSearching, setIsSearching] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [currentSearchResultIndex, setCurrentSearchResultIndex] = useState(0);

  const clearSearch = useCallback(() => {
    setSearchQuery("");
    setSearchResults([]);
    setCurrentSearchResultIndex(0);
  }, []);

  return {
    searchQuery,
    setSearchQuery,
    isSearching,
    setIsSearching,
    searchResults,
    setSearchResults,
    currentSearchResultIndex,
    setCurrentSearchResultIndex,
    clearSearch,
  };
};
